<template>
    <div id="recruiter_new_candidates" class="flex_content">

        <div id="context_bar">

            <TopbarGoPositionsList />
            <TopbarSearchPosition />
            <TopbarAddPosition />
        </div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1">
                    {{ $t('modules.positions.compare.title') }}
                </h1>
            </template>
        </titlePage>

        <div id="chart" class="container">

            <div class="chart_labels_container">
                <div class="evalution_item_name"
                    v-for="(evaluation, index) in evaluations"
                    :index="index" :key="evaluation.id"
                    @click="toggleDataChart(evaluation)"
                    :class="{active: activeEvals.includes(evaluation.id)}"
                    v-if="evaluation.completed">

                    <div class="eval_color" :style="evalColorActiveClass(evaluation)"></div>
                    <div class="eval_username">
                        {{ evaluation.candidate_username }} ({{ evaluation.saven_test.matching_score.toFixed(0) }}%)
                    </div>
                </div>
            </div>

            <RadarChart :chartData="chartDatas" />

        </div>

        <transition name="notif-slide-up">
            <alert v-if="showErrorNotif" context="danger" @close="showErrorNotif=false">Vous ne pouvez afficher que 5 évaluations simultanément sur le diagramme.</alert>
        </transition>

    </div>

</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import TopbarSearchPosition from "../components/topbar/topbarSearchPosition"
import TopbarAddPosition from "../components/topbar/topbarAddPosition"
import TopbarGoPositionsList from "../components/topbar/topbarGoPositionsList"

import RadarChart from './radarChart'


export default {
    name: 'PositionCompare',
    components: {
        TitlePage,
        TopbarSearchPosition,
        TopbarAddPosition,
        TopbarGoPositionsList,
        RadarChart
    },
    created(){
        this.$store.dispatch('PositionStore/getPosition', this.$route.params.id).then((resp) => {
            const refScores = Object.values(this.currentRef.sight3_scores).map(x => x.toFixed(0))
            this.chartDatas.push({
                label: 'referentiel',
                data: refScores,
                lineTension: 0.1,
                borderColor: "rgba(150, 150, 150, 0) ",
                backgroundColor: "rgba(150, 150, 150, 0.35) ",
                pointRadius: 0
            })
            this.$store.dispatch('PositionStore/getPosition', this.$route.params.id).then(() => {
                this.$store.dispatch('PositionStore/getPositionEvals', {position_id: this.$store.state.PositionStore.currentPosition.id, only_completed: 1, current_page: 1, item_per_page: 50 })
            })
        })
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        evaluations(){
            if(this.$store.state.PositionStore.PositionEvals){
                return this.$store.state.PositionStore.PositionEvals.filter((evaluation) => {
                    return evaluation.completed == true
                })
            }else{
                return false
            }
        },
        currentRef(){
            return this.currentPosition.sight_ref
        }
    },
    data(){
        return {
            chartDatas: [],
            colors: [ '#CEAE47', '#D94999', '#2FCBBF', '#374654', '#898AC9' ],
            usedColors: [],
            activeEvals: [],
            labelColors: {},
            showErrorNotif: false
        }
    },
    methods: {
        evalColorActiveClass(evaluation){
            return {'border-color': this.labelColors[evaluation.id]}
        },
        nextColor(evaluation){
            for (let i = 0; i < this.colors.length; i++) {
                if(!this.usedColors.includes(this.colors[i])){
                    this.usedColors.push(this.colors[i])
                    this.$set(this.labelColors, evaluation.id, this.colors[i])
                    return this.colors[i]
                }
            }
        },
        removeColor(evaluation){
            const color = this.labelColors[evaluation.id]
            this.usedColors.splice(this.usedColors.indexOf(color), 1)
            this.$delete(this.labelColors, evaluation.id)
        },
        toggleDataChart(evaluation){

            const currentIndex = this.chartDatas.length - 1
            const evalInArray = this.chartDatas.find(x => x.label == evaluation.candidate_username)

            if(evalInArray){
                this.chartDatas.splice(this.chartDatas.indexOf(evalInArray), 1)
                this.activeEvals.splice(this.activeEvals.indexOf(evaluation.id), 1)
                this.removeColor(evaluation)
            }else{
                if(this.chartDatas.length < 5){
                    const evalScores = Object.values(evaluation.saven_test.s3_skills_scores).map(x => x.toFixed(0))
                    const evalData = {
                        label: evaluation.candidate_username,
                        data: evalScores,
                        fill: false,
                        lineTension: 0.1,
                        borderColor: this.nextColor(evaluation),
                        pointRadius: 0
                    }
                    this.activeEvals.push(evaluation.id)
                    this.chartDatas.push(evalData)
                }else{
                    this.showErrorNotif = true
                }
            }
        }
    }
}
</script>

<style lang="scss">
#recruiter_new_candidates{
    background: $white;
}
#chart{
    width: 100%;
    max-width: 1100px;
    .chart_labels_container{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .evalution_item_name{
            display: flex;
            align-items: center;
            margin: 4px 8px;
            cursor: pointer;
            .eval_color{
                height: 16px;
                width: 16px;
                border: 2px solid grey;
                margin-right: 8px;
                border-radius: 100%;
                transition: .3s all;
            }
            &.active{
                .eval_color{
                    border-width: 8px;
                }
            }
            .eval_username{

            }
        }
    }
}



</style>
